import { render, staticRenderFns } from "./Arrival.vue?vue&type=template&id=1d50a9e0&"
import script from "./Arrival.vue?vue&type=script&lang=js&"
export * from "./Arrival.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports